import React, { Fragment } from 'react'
import styled from 'styled-components'

const ApiDescription = ({ attributes, children, element, editor }) => <Description {...attributes}>{children}</Description>

export default ApiDescription

const Description = styled.div`
  margin-bottom: 20px;
`
